import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FormApplication from './FormApplication';
import DocuSignCallback from './DocuSignCallback';
import AdminPage from './AdminPage';
import SigningPage from './SigningPage';
import { Container, Box, Typography, Button } from '@mui/material';

// New component for the root path
const RootPathMessage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {/* Logo */}
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <img
          src={`/${import.meta.env.VITE_LOGO_PATH}`}
          alt="Logo"
          style={{ maxWidth: '400px' }}
        />
      </Box>
      
      <Box sx={{ mt: 4, p: 4, bgcolor: '#f5f5f5', borderRadius: 2 }}>
        <Typography variant="h5" gutterBottom align="center" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
          Start a New Application
        </Typography>
        
        <Typography variant="body1" paragraph align="center" sx={{ mt: 3 }}>
          To start a new application, please contact:
        </Typography>
        
        <Typography variant="h6" align="center" sx={{ color: '#1976d2', fontWeight: 'bold', my: 2 }}>
          {import.meta.env.VITE_EMAIL_DOCUMENTS}
        </Typography>
        
        <Typography variant="body2" align="center" sx={{ mt: 3 }}>
          Our team will assist you with starting your application process and provide you with the necessary instructions.
        </Typography>
        
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
          <Button 
            variant="contained"
            color="primary"
            component="a"
            href={`mailto:${import.meta.env.VITE_EMAIL_DOCUMENTS}`}
          >
            Email Us
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin page route */}
        <Route path="/admin" element={<AdminPage />} />
        
        {/* Signing page route - must come before the generic formId route */}
        <Route path="/:formId/sign/:token" element={<SigningPage />} />
        
        {/* Main form application route */}
        <Route path="/:formId" element={<FormApplication />} />
        
        {/* DocuSign callback route - don't try to load form data here */}
        <Route path="/docusign/callback" element={<DocuSignCallback />} />
        
        {/* Root path now shows the contact message */}
        <Route path="/" element={<RootPathMessage />} />
      </Routes>
    </Router>
  );
}

export default App;